export default __webpack_public_path__ + "static/media/quick-reply.b4c27842.svg";